import { axios } from "utils";

import { PUBLIC_MODULES_URL } from "consts";

import { DefaultHarvestData } from "models";

const endpoint = `${PUBLIC_MODULES_URL}/crops`;

export const updateHarvestData = async (data: {
  cropId: string;
  dryMass: boolean | null;
  harvestCompleted: boolean;
  harvestEnd: string;
  harvestStart: string;
  seedingEnd: string;
  seedingStart: string;
  yieldFinal: number | null;
}): Promise<{ success: boolean }> => axios.put(`${endpoint}/${data.cropId}/harvest-data`, { data });

export const getDefaultHarvestData = async (data: {
  cropId: string;
  regionId?: string;
  signal: AbortSignal;
}): Promise<{ success: boolean; harvestData: DefaultHarvestData }> => axios.get(`${endpoint}/harvest-data`, { data });
